(function () {
  document.querySelectorAll('[data-simple-config]').forEach((config) => {
    const root = config.closest('.custom-cake');
    if (root) initProductSimple(root, config);
  });

  function initProductSimple(root, config) {
    const form = root.querySelector('.product-express__form form');
    if (!form) return;

    const dateInput = root.querySelector('[data-simple-date-input]');
    const dateError = root.querySelector('[data-simple-date-error]');
    const submitButton = root.querySelector('[data-simple-submit]');
    const variantIdInput = root.querySelector('.product-express__variant-id-fallback');
    const errorWrapper = root.querySelector('.product-express__error-message-wrapper');
    const errorMessage = root.querySelector('.product-express__error-message');
    const quantityInput = root.querySelector('[data-quantity-input]');
    const quantityDecrease = root.querySelector('[data-quantity-decrease]');
    const quantityIncrease = root.querySelector('[data-quantity-increase]');

    const CLOSED_WEEKDAY = 0;
    const CLOSED_MESSAGE = dateError ? dateError.textContent.trim() : '';

    // Sobota jest dniem odbioru, ale nie dniem produkcji (Regulamin § 2),
    // więc czas realizacji liczy się od poniedziałku do piątku. Niedziela to
    // jedyny dzień, w którym nie da się nic odebrać.
    function isBusinessDay(date) {
      const day = date.getDay();
      return day !== 0 && day !== 6;
    }

    function toDateInputValue(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return year + '-' + month + '-' + day;
    }

    function parseSetting(value) {
      if (!value) return null;
      const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value.trim());
      if (!match) return null;
      const date = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
      return isNaN(date.getTime()) ? null : date;
    }

    function leadTimeDate() {
      const parsedDays = parseInt(config.dataset.minBusinessDays, 10);
      const businessDays = isNaN(parsedDays) ? 1 : parsedDays;
      const date = new Date();
      date.setHours(0, 0, 0, 0);
      let added = 0;
      while (added < businessDays) {
        date.setDate(date.getDate() + 1);
        if (isBusinessDay(date)) added++;
      }
      return date;
    }

    // Dolną granicę wyznacza to, co późniejsze: czas realizacji albo początek
    // okna sezonowego. Dzięki temu „odbiór od 29.10” nie pozwala zamówić na
    // 29.10 wieczorem 28.10, jeśli produkcja potrzebuje doby.
    function earliestPickupDate() {
      const lead = leadTimeDate();
      const windowStart = parseSetting(config.dataset.pickupFrom);
      return windowStart && windowStart > lead ? windowStart : lead;
    }

    function latestPickupDate() {
      return parseSetting(config.dataset.pickupTo);
    }

    function formatPl(date) {
      return date.toLocaleDateString('pl-PL');
    }

    // Minimum i maksimum są też wpisane w atrybuty "min"/"max", ale wyłącznie
    // po to, żeby wyszarzyć dni w kalendarzu. Chrome i Firefox odmawiają
    // wysłania formularza poza zakresem, Safari wysyła mimo to — więc regułą
    // rządzi ta funkcja, nie atrybut.
    function pickupDateIssue() {
      if (!dateInput || !dateInput.value) return null;
      const [year, month, day] = dateInput.value.split('-').map(Number);
      const selected = new Date(year, month - 1, day);
      if (isNaN(selected.getTime())) return 'Wybierz poprawną datę odbioru.';
      if (selected.getDay() === CLOSED_WEEKDAY) return CLOSED_MESSAGE;

      const earliest = earliestPickupDate();
      if (selected < earliest) {
        return 'Najwcześniejszy możliwy termin odbioru to ' + formatPl(earliest) + '.';
      }

      const latest = latestPickupDate();
      if (latest && selected > latest) {
        return 'Ta oferta kończy się ' + formatPl(latest) + ' — wybierz wcześniejszy termin odbioru.';
      }

      return null;
    }

    function showDateIssue(message) {
      if (!dateError) return;
      dateError.textContent = message || CLOSED_MESSAGE;
      dateError.hidden = !message;
    }

    function showError(message) {
      if (!errorWrapper || !errorMessage) return;
      errorMessage.textContent = message;
      errorWrapper.hidden = false;
    }

    if (dateInput) {
      const earliest = earliestPickupDate();
      const latest = latestPickupDate();
      dateInput.min = toDateInputValue(earliest);
      if (latest) dateInput.max = toDateInputValue(latest);

      // Okno, które już minęło, nie da się domknąć żadnym wyborem — lepiej
      // powiedzieć to wprost, niż zostawić kalendarz bez jednej klikalnej daty.
      if (latest && earliest > latest) {
        showError('Zamówienia w tej ofercie są już zamknięte.');
        if (submitButton) submitButton.disabled = true;
      }

      dateInput.addEventListener('change', () => {
        if (!dateInput.value) {
          showDateIssue(null);
          return;
        }
        const issue = pickupDateIssue();
        // Niedzielę czyścimy, bo nie da się jej poprawić „o jeden dzień”.
        // Datę spoza zakresu zostawiamy, żeby klient widział, co wybrał.
        if (issue === CLOSED_MESSAGE) dateInput.value = '';
        showDateIssue(issue);
      });
    }

    function quantityLimits() {
      const max = parseInt(quantityInput && quantityInput.max, 10);
      return { max: isNaN(max) ? null : max };
    }

    function clampQuantity(value) {
      const { max } = quantityLimits();
      let next = Math.max(1, parseInt(value, 10) || 1);
      if (max !== null) next = Math.min(next, Math.max(1, max));
      return next;
    }

    if (quantityInput && quantityDecrease && quantityIncrease) {
      quantityDecrease.addEventListener('click', () => {
        quantityInput.value = clampQuantity(parseInt(quantityInput.value, 10) - 1);
      });
      quantityIncrease.addEventListener('click', () => {
        quantityInput.value = clampQuantity(parseInt(quantityInput.value, 10) + 1);
      });
      quantityInput.addEventListener('change', () => {
        quantityInput.value = clampQuantity(quantityInput.value);
      });
    }

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      if (errorWrapper) errorWrapper.hidden = true;

      const variantId = variantIdInput && variantIdInput.value;
      if (!variantId) {
        showError('Nie udało się rozpoznać produktu. Odśwież stronę i spróbuj ponownie.');
        return;
      }

      if (dateInput && !dateInput.value) {
        showError('Wybierz datę odbioru.');
        dateInput.focus();
        return;
      }

      const dateIssue = pickupDateIssue();
      if (dateIssue) {
        showError(dateIssue);
        showDateIssue(dateIssue);
        dateInput.focus();
        return;
      }

      const properties = {};
      form.querySelectorAll('[name^="properties["]').forEach((field) => {
        const key = field.name.match(/properties\[(.+)\]/)[1];
        if (field.type === 'checkbox' || field.type === 'radio') {
          if (field.checked) properties[key] = field.value;
          return;
        }
        if (field.value) properties[key] = field.value;
      });

      const quantity = quantityInput ? clampQuantity(quantityInput.value) : 1;

      if (submitButton) submitButton.disabled = true;

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: quantity, properties: properties }] }),
      })
        .then((response) => response.json().then((data) => ({ ok: response.ok, data: data })))
        .then(({ ok, data }) => {
          if (!ok) {
            throw new Error(data.description || data.message || 'Nie udało się dodać produktu do koszyka.');
          }
          window.location.href = window.Shopify.routes.root + 'cart';
        })
        .catch((error) => {
          showError(error.message);
        })
        .finally(() => {
          if (submitButton) submitButton.disabled = false;
        });
    });
  }
})();
